import { combineReducers } from "redux";

import announcementReducer from "./announcement.reducer";
import authReducer from "./auth.reducer";
import profileReducer from "./profile.reducer";
import studentReducer from "./student.reducer";
import communityReducer from "./community.reducer";
import eventReducer from "./event.reducer";
import faqReducer from "./faq.reducer";
import documentReducer from "./document.reducer";
import feeReducer from "./fee.reducer";
import cartReducer from "./cart.reducer";
import paymentReducer from "./payment.reducer";
import componentReducer from "./component.reducer";
import metricsReducer from "./metrics.reducer";
import careerReducer from "./career.reducer";
import deliveryFeeReducer from "./delivery.reducer";
import chatReducer from "./chat.reducer";
import modalReducer from "./modal.reducer";

const rootReducer = combineReducers({
  announcementReducer,
  authReducer,
  profileReducer,
  studentReducer,
  communityReducer,
  eventReducer,
  faqReducer,
  documentReducer,
  feeReducer,
  cartReducer,
  paymentReducer,
  componentReducer,
  metricsReducer,
  careerReducer,
  deliveryFeeReducer,
  chatReducer,
  modalReducer,
});

export default rootReducer;
